import React from 'react'
import { SvgIconProps } from './Home'

const OrganizationIcon = ({ fill, width, height }: SvgIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "17"}
      height={height ?? "15"}
      viewBox="0 0 17 15"
    >
      <path
        fill={fill ?? "#353535"}
        d="M14.34 13.333H2.66c-.462 0-.81.357-.81.833s.348.834.81.834h11.68c.463 0 .81-.357.81-.834 0-.476-.347-.833-.81-.833zM16.653 2.976c-.231-.238-.578-.238-.925-.119l-3.816 1.667L9.252.357C9.02.12 8.789 0 8.558 0c-.347 0-.578.119-.81.357l-2.66 4.167-3.932-1.667c-.23-.119-.578 0-.81.12C0 3.213 0 3.57 0 3.928l1.85 7.5c.116.357.463.714.81.714h11.68c.347 0 .694-.238.81-.714l1.85-7.5c0-.358 0-.715-.347-.953zM14.918 5.12l-1.272 5.12H3.238l-1.156-5.12 2.89 1.19c.348.12.81 0 1.042-.357l2.544-3.571 2.428 3.69a.918.918 0 001.041.358l2.891-1.31z"
      ></path>
    </svg>
  )

export default OrganizationIcon